import { render } from "./LiveSquare.vue?vue&type=template&id=dedb71b4&scoped=true"
import script from "./LiveSquare.vue?vue&type=script&lang=js"
export * from "./LiveSquare.vue?vue&type=script&lang=js"

import "./LiveSquare.vue?vue&type=style&index=0&id=dedb71b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dedb71b4"]])

export default __exports__